import { supabase } from "@/integrations/supabase/client";

export const platformSupabaseClient = supabase;
